import { createApp } from "vue";
import App from "./App.vue";
import { createVuetify } from "vuetify";
import 'vuetify/styles';
import "@mdi/font/css/materialdesignicons.css";
import router from "./router";

const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

const vuetify = createVuetify({
  theme: {
    defaultTheme: prefersDark ? 'dark' : 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          primary: "#156B4C",
          secondary: "#4E4AA6",
          warning: "#FAD42F",
          info: "#221E1F",
          error: "#D12626",
          'accent-primary': "#009464",
          'accent-secondary': "#82D8A4",
          'deep-purple-lighten-4': "#C0C6FC",
          'deep-secondary': "#6C76D3",
          'grey-darken-4': "#221E1F"
        },
      },
      dark: {
        dark: true,
        colors: {
          primary: "#4E4AA6",
          secondary: "#156B4C",
          warning: "#FAD42F",
          error: "#D12626",
          info: "#CCCCCC",
          'deep-secondary': "#82D8A4",
          'grey-darken-4': "#cccccc",
          'accent-secondary': "#C0C6FC",
        },
      },
    },
  },
});
createApp(App).use(vuetify).use(router).mount("#app");

